import React from "react"
import { Ring } from "@uiball/loaders"
const SubmitLoader = () => {
  return <Ring color="white" size={70} />
}
export default SubmitLoader
